/* assets/zoom-init.js */
(function () {
  // wait until a condition is true (jQuery/plugin/gallery ready)
  function waitFor(cond, cb, tries = 60) {
    (function check() {
      if (cond()) return cb();
      if (--tries <= 0) return;
      setTimeout(check, 250);
    })();
  }

  function bindZoomAll() {
    var $ = window.jQuery;
    if (!$ || !$.fn || !$.fn.lightzoom) return;

    // Let mouse events reach the main image
    $('.product__media-toggle, .gallery-cursor, .product__modal-opener, use-animate')
      .css('pointer-events', 'none');
    $('.product__media, .product__media img').css('pointer-events', 'auto');

    // Find every main image inside the gallery (not the thumbs)
    var $imgs = $('media-gallery .product__media img, .product__media-wrapper .product__media img')
      .filter(function () {
        var $el = $(this);
        // exclude thumbnails and non-image media
        if ($el.closest('.thumbnail-list, .thumbnail-slider').length) return false;
        if ($el.closest('deferred-media,[data-media-type="video"],[data-media-type="external_video"]').length) return false;
        return true;
      });

    $imgs.each(function () {
      var $img = $(this);
      if ($img.data('lz-bound')) return; // already bound

      // ensure it has a concrete src (lazy images often only have currentSrc)
      if (!$img.attr('src') && this.currentSrc) $img.attr('src', this.currentSrc);

      // (re)bind when ready
      var doBind = function () {
        $img.off('.lz').lightzoom({ zoomPower: 3, glassSize: 220 });
        $img.data('lz-bound', true);
      };

      if (this.complete && $img.width() > 0) {
        doBind();
      } else {
        $img.one('load.lz', doBind);
      }
    });
  }

  // --- init & rebind triggers ---
  function initAfterReady() {
    var $ = window.jQuery;

    bindZoomAll();

    // When Shopify re-renders a section/block
    document.addEventListener('shopify:section:load', bindZoomAll);
    document.addEventListener('shopify:block:select', bindZoomAll);

    // After thumbs/arrows swap media
    if ($) {
      $(document).on('click', '.thumbnail-list__item, .thumbnail, .product__media-toggle', function () {
        setTimeout(bindZoomAll, 0);
      });
    }

    // Safety net after full load
    window.addEventListener('load', bindZoomAll);
  }

  function init() {
    // Wait for jQuery + plugin + gallery to exist before wiring anything
    waitFor(function () {
      return (
        window.jQuery &&
        window.jQuery.fn &&
        window.jQuery.fn.lightzoom &&
        document.querySelector('.product__media')
      );
    }, initAfterReady);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
